export default (description) => {
  const descriptionToChartKey = {
    'DEALER_INVENTORY': 'Dealer Inventory',
    'PROCESSING_CENTER': 'Processing Center',
    'TRANSIT_TO_VPS': 'In Transit to VPC',
    'PRODUCED_NOT_SHIPPED': 'Produced Not Shipped',
    'SCHEDULED': 'Scheduled/In Production',
    'ON_ORDER': 'On Order',
    'UNSUBMITTED': 'Not Submitted Quota',
  }
  return descriptionToChartKey[description];
};
